import React, { useEffect, useState } from "react";
import _ from "lodash";
import Form from "forms/Form";
import { EPISODE_CATEGORIES, EVENTS } from "api/config/endpoints";
import formWrapper from "hoc/formWrapper";
import { useParams } from "react-router";
import useMultilangForm from "hooks/useMultilangForm";


const EpisodeCategoryForm = (props) => {
    const { event } = useParams()

    const [defaultValues, setDefaultValues] = useState({});
    const [itemId, setItemId] = useState(null);

    const endpoint = [
        EVENTS,
        event,
        EPISODE_CATEGORIES
    ].join("/");

    const {
        _reset,
        _selectedLangCode,
        _defaultParams,
        _languageSelect
    } = useMultilangForm({
        label: "Select language",
        modal: true
    })

    useEffect(() => {
        setDefaultValues(props.item)
        setItemId(_.get(props, "item.id"))
    }, [props.item])

    const getValue = (name, type) => {
        let value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;

        if (["title"].includes(name)) { //"title", 
            value = _.get(value, _selectedLangCode) || ""
        }
        switch (type) {
            case "bool":
                return value !== 0;
            default:
                return value;
        }
    };

    const onSubmit = (data) => {

        if (!_.isEmpty(data) && data !== defaultValues) {
            setDefaultValues(data)
            try {
                setItemId(data.id)
                props.onSubmit(data)
            }
            catch (e) {
                console.error(e)
            }
        }
    }

    const onChange = (key, value) => {
        setDefaultValues({
            ...defaultValues,
            [key]: {
                [_selectedLangCode]: value
            }
        });
    }

    const defaultParams = () => {
        return _defaultParams
    }

    const onRequestClose = () => {
        _reset()
        props.onAbortClicked()
    }

    let fields = 1
        ? [
            {
                elementType: "input",
                id: "title",
                name: "title",
                labelText: "Title",
                value: getValue("title"),
            }
        ]
        : [];

    return (
        <>
            {_languageSelect}
            <div className={props.className} key={`form-episode-${itemId}-${_selectedLangCode}`}>
                <Form
                    blockTouched={true}
                    itemId={itemId}
                    fields={fields}
                    endpoint={endpoint}
                    loaded={true}
                    setAutoId={true}
                    modal={true}
                    defaultParams={defaultParams()}
                    onSubmit={(data) => onSubmit(data)}
                    abortButton={true}
                    onRequestClose={onRequestClose}
                    onChange={onChange}
                    primaryButtonDisabled={getValue("title").trim().length === 0}
                    key={"episode-category-form-" + itemId}
                />
            </div>
        </>
    );
};

export default formWrapper(EpisodeCategoryForm)
